export const fetchOrder = (hookParamCall, serverObject ,serverId = null) => {
    hookParamCall('');
    hookParamCall({
        server_id: serverId ? serverId : serverObject.id
    })
}